import compareStoredColumns from '../functions/compare-stored-columns'

export default ({ Vue }) => {
    Vue.prototype.$compareStoredColumns = compareStoredColumns
}
